var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "subscription-onboarding-container"
  }, [_c('v-row', {
    class: {
      'heading-l-large mb-4 ml-1': _vm.$breakpoint.mobileAndDown,
      'heading-m-large mb-2 ml-1': _vm.$breakpoint.tabletAndUp
    }
  }, [_vm.$breakpoint.mobileAndUp ? _c('h1', {
    staticClass: "primary--text heading",
    class: {
      'heading-l-large': _vm.$breakpoint.mobileAndDown,
      'heading-m-large': _vm.$breakpoint.tabletAndUp
    }
  }, [_vm._v(" Select a plan ")]) : _vm._e()]), _vm.loaded ? _c('v-row', {
    class: {
      'flex-column-reverse': _vm.$breakpoint.mobileAndDown
    },
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('div', {
    class: {
      'mb-15': _vm.$vuetify.breakpoint.height < 714
    }
  }, _vm._l(_vm.plans, function (plan, index) {
    return _c('PlanCardOnboardingComponent', {
      key: index,
      attrs: {
        "plan-info": plan
      },
      on: {
        "select-card": _vm.selectCard
      }
    });
  }), 1)]), _c('v-col', {
    class: {
      'align-self-center': _vm.$breakpoint.tabletAndUp && !_vm.planSelected,
      'pl-6': _vm.$breakpoint.tabletAndUp
    },
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-row', {
    staticClass: "header-container",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', [_vm.$breakpoint.mobileAndUp && !_vm.planSelected || _vm.$breakpoint.smallMobileAndDown ? _c('div', {
    staticClass: "text-center"
  }, [_c('SelectPlanStepComponent', {
    attrs: {
      "size": _vm.sizeImage
    }
  })], 1) : _vm._e(), _vm.$breakpoint.tabletAndUp && _vm.planSelected ? _c('div', {
    staticClass: "shadow-card border-radius-small pa-4",
    class: {
      'selected-card': !_vm.planSelected.isLifetime,
      'card-base-background': !_vm.planSelected.isLifetime,
      'lifetime-background': _vm.planSelected.isLifetime
    },
    attrs: {
      "cols": "12"
    }
  }, [_vm.planSelected.yearCycle && !_vm.planSelected.isLifetime ? _c('div', {
    staticClass: "chip-billing-cycle text text-l-small-regular mb-4"
  }, [_vm._v(" " + _vm._s(_vm.planSelected.yearCycle) + " year subscription ")]) : _vm._e(), _vm.planSelected.yearCycle && _vm.planSelected.isLifetime ? _c('div', {
    staticClass: "chip-billing-cycle text text-l-small-regular mb-4"
  }, [_vm._v(" " + _vm._s(_vm.planSelected.yearCycle) + " subscription ")]) : _vm._e(), _c('ul', {
    staticClass: "list-style-none pl-0"
  }, [_vm._l(_vm.planSelected.benefits, function (benefit, index) {
    return _c('li', {
      key: index,
      staticClass: "text text-l-small-regular",
      class: {
        'mt-4': index > 0,
        'grey--text text--darken-4': !_vm.planSelected.isLifetime,
        'white--text': _vm.planSelected.isLifetime
      }
    }, [_c('ph-check', {
      staticClass: "mr-2",
      attrs: {
        "size": "24",
        "weight": "light",
        "color": "var(--v-secondary-base)"
      }
    }), _c('p', {
      staticClass: "mb-0",
      domProps: {
        "innerHTML": _vm._s(benefit)
      }
    })], 1);
  }), _vm._l(_vm.planSelected.limitations, function (limitation, index) {
    return _c('li', {
      key: index + _vm.uniqueKeysHelper(),
      staticClass: "text mt-4 text-l-small-regular",
      class: {
        'white--text': _vm.planSelected.isLifetime,
        'grey--text text--darken-4': !_vm.planSelected.isLifetime
      }
    }, [_c('ph-x', {
      staticClass: "mr-2",
      attrs: {
        "size": "24",
        "weight": "light",
        "color": "var(--v-error-base)"
      }
    }), _c('p', {
      staticClass: "mb-0 text-decoration-line-through"
    }, [_vm._v(_vm._s(limitation))])], 1);
  })], 2)]) : _vm._e()]), _vm.$breakpoint.smallMobileAndDown ? _c('v-col', {
    staticClass: "align-self-center"
  }, [_c('h1', {
    staticClass: "heading heading-m-small primary--text"
  }, [_vm._v("Select a plan")])]) : _vm._e()], 1), _vm.$breakpoint.tabletAndUp ? _c('v-row', {
    staticClass: "fixed-button-select-plan",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('v-btn', {
    staticClass: "heading heading-s-small align-self-center white--text unaltered-text-cap shadow-light-button px-6",
    attrs: {
      "disabled": !_vm.planSelected,
      "ripple": "",
      "depressed": "",
      "block": _vm.$breakpoint.mobileAndDown,
      "height": _vm.$breakpoint.mobileAndDown ? '44px' : '36px',
      "color": "primary"
    },
    on: {
      "click": _vm.confirmPlanSelection
    }
  }, [_vm._v(" Select plan ")])], 1)], 1) : _vm._e()], 1)], 1) : _c('ProgressBarComponent', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.loaded,
      expression: "!loaded"
    }],
    attrs: {
      "title": 'plans'
    }
  }), _vm.$breakpoint.mobileAndDown ? _c('v-row', {
    staticClass: "fixed-button-select-plan",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('v-btn', {
    staticClass: "heading heading-s-small align-self-center white--text unaltered-text-cap shadow-light-button px-6",
    attrs: {
      "disabled": !_vm.planSelected,
      "ripple": "",
      "depressed": "",
      "block": _vm.$breakpoint.mobileAndDown,
      "height": _vm.$breakpoint.mobileAndDown ? '44px' : '36px',
      "color": "primary"
    },
    on: {
      "click": _vm.confirmPlanSelection
    }
  }, [_vm._v(" Select plan ")])], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }